module.exports = __webpack_public_path__ + "img/userbk@3x.12f58953.png";